import { mapActions, mapGetters, mapMutations } from 'vuex'
import dialogView from './dialog-view/index.vue'

export default {
  name: 'setting-education-categories',
  data () {
    return {
      page: 1,
      showRemoveDialog: false,
      removingItem: null
    }
  },
  components: {
    dialogView
  },
  computed: {
    ...mapGetters({
      list: 'settingEducationCategories/list',
      limit: 'settingEducationCategories/limit',
      listLength: 'settingEducationCategories/listLength',
      isLoading: 'settingEducationCategories/isLoading',
      isListLoading: 'settingEducationCategories/isListLoading',
      openDialogView: 'settingEducationCategories/openDialogView',

      checkList: 'settingEducationCategories/checkList',

    }),
    headers () {
      return [
        {
          text: 'Title',
          value: 'title'
        },
        {
          text: 'Slug',
          value: 'slug'
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions'
        }
      ]
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    ...mapActions({
      fetchList: 'settingEducationCategories/GET_LIST',
      remove: 'settingEducationCategories/DELETE',
      fetchBasicLocales: 'setting/GET_BASIC_LOCALES',
      checkItemInMaterials: 'settingEducationCategories/CHECK_ITEM_IN_MATERIALS',
    }),
    ...mapMutations({
      changeSkip: 'settingEducationCategories/CHANGE_SKIP',
      changeDialogView: 'settingEducationCategories/CHANGE_DIALOG_VIEW',
      setList: 'settingEducationCategories/SET_LIST',
      changeEditId: 'settingEducationCategories/CHANGE_EDIT_ID',
      resetCheckList: 'settingEducationCategories/RESET_CHECK_LIST'
    }),
    changePagination (index) {
      this.changeSkip(this.limit * (index - 1))
      this.$vuetify.goTo(0)
      this.fetchList()
    },
    changeDialog (status = false, item = null) {
      this.changeEditId(item.id)
      this.changeDialogView(status)
    },
    removeCategory () {
      this.remove(this.removingItem).then(() => {
        this.showRemoveDialog = false
        this.$toasted.success(this.$t('success_deleted'))
      })
    },

    changeDialogDeleteItem (item, e) {
        let $btn = e.currentTarget;

        this.isLoadingCheckItem = true;
        $btn.classList.add('has-disabled');

        this.resetCheckList();

        this.checkItemInMaterials(item.id).then(() => {
            $btn.classList.remove('has-disabled');
            this.isLoadingCheckItem = false;

			this.showRemoveDialog = true;
			this.removingItem = item;
        })
    }
  },
  destroyed () {
    this.setList([])
  }
}
